import { defineCustomElement } from "vue";
import { Register } from "..";
import F360CalloutPlanoDeContaCe from "./F360CalloutPlanoDeConta.ce.vue";

const _register: Register = {
  register() {
    if (!customElements.get("vc-callout-plano-de-conta")) {
      const CustomElement = defineCustomElement(F360CalloutPlanoDeContaCe);
      customElements.define("vc-callout-plano-de-conta", CustomElement);
    }
  }
};

export default _register;
